import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/t/users')({
  staticData: { breadcrumb: 'Users', breadcrumbKey: 'K_BREADCRUMB_USERS' },
});
